import mutations from './mutations';
import actions from './actions';
import getDefaultState from './get-default-state';

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
};
